// getNav 接口返回的列表配置（id）
export function navList(id) {
  if (
    id == 1 ||
    id == 2 ||
    id == 3 ||
    id == 4 ||
    id == 5 ||
    id == 6 ||
    id == 7 ||
    id == 8 ||
    id == 25||
    id == 21
  )
    return true;
  return false;
}

// 数据管理菜单排序（定义固定顺序）
export const DATA_MENU_ORDER = [1, 2, 3, 4, 5, 6, 21, 7, 25, 8];

export function navWaList(id) {
  if (
    id == 10 ||
    id == 11 ||
    id == 12 ||
    id == 13 ||
    id == 14 ||
    id == 15 ||
    id == 16 ||
    id == 17 ||
    id == 18 ||
    id == 19 ||
    id == 20 ||
    id == 22 ||
    id == 23 ||
    id == 24 ||
    id == 26 ||
    id == 27 ||
    id == 28
  )
    return true;
  return false;
}

// 小程序菜单排序（定义固定顺序）
export const WA_MENU_ORDER = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 26, 27, 28];
// 获取登录成功后显示的页面 主要是判断权限
export function getFirstMeun(list) {
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    if (item.show === "Y") {
      item.index = (navList(item.id) ? "1-" : "2-") + (i + 1);
      return item;
    }
  }
  return null;
}

// 菜单栏权限是否变化
export function meunsShowChange(n_meuns, s_meuns) {
  if (n_meuns == undefined || s_meuns == undefined) return false;
  for (var i = 0; i < n_meuns.length; i++) {
    var n_meun = n_meuns[i];
    var s_meun = s_meuns[i];
    if (n_meun.id != s_meun.id) return true;
    if (n_meun.show != s_meun.show) return true;
  }
  return false;
}
// 当前权限是否变化
export function meunNotChange(meun, newList) {
  for (var i = 0; i < newList.length; i++) {
    var newItem = newList[i];
    if (newItem.id == meun.id) {
      return newItem.show == meun.show;
    }
  }
  return null;
}
// 菜单是否不显示
export function meunNoOneShow(list) {
  let len = list.length;
  let count = 0;
  for (var i = 0; i < len; i++) {
    if (list[i].show == "N") count++;
  }
  return count == len;
}

// getNav接口返回的列表配置（id）
export function getMeunRouter4MeunId(id) {
  let path = "/data/users";
  switch (id) {
    case 1:
      path = "/data/users";
      break;
    case 2:
      path = "/data/educations";
      break;
    case 3:
      path = "/data/jobs";
      break;
    case 4:
      path = "/data/journals";
      break;
    case 5:
      path = "/data/honors";
      break;
    case 6:
      path = "/data/op-log";
      break;
    case 7:
      path = "/data/scan-word";
      break;
    case 8:
      path = "/data/admin-setting";
      break;
    case 10:
      path = "/wxapp/banners";
      break;
    case 11:
      path = "/wxapp/activity";
      break;
    case 12:
      path = "/wxapp/newsList";
      break;
    case 13:
      path = "/wxapp/memorabiliaList";
      break;
    case 14:
      path = "/wxapp/associationList";
      break;
    case 15:
      path = "/wxapp/authentication";
      break;
    case 16:
      path = "/wxapp/enterprise";
      break;
    case 17:
      path = "/wxapp/welfare";
      break;
    case 18:
      path = "/wxapp/donation_list";
      break;
    case 20:
      path = "/wxapp/integral";
      break;
    case 21:
      path = "/data/apply-log";
      break;
    case 22:
      path = "/wxapp/photoExamine";
      break;
    case 23:
      path = "/wxapp/agreemenManager";
      break;
    case 24:
      path = "/wxapp/surveyManager";
      break;
    case 25:
      path = "/data/statisticalData";
      break;
    case 26:
      path = "/wxapp/statistic";
      break;
    case 27:
      path = "/wxapp/wishes";
      break;
    case 28:
      path = "/wxapp/video";
      break;
  }
  return path;
}



// WEBPACK FOOTER //
// ./src/utils/constant_router.js